module.exports = __webpack_public_path__ + "assets/img/bg-line-driver-ddf008e6.png";